export const NewVehicle = {
  labelRegistration: 'Parametrizar Matriculas'
}



// WEBPACK FOOTER //
// ./src/translations/pt/miscellaneous/NewVehicle.js